var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5C22 17.5751 17.0751 22.5 11 22.5C4.92487 22.5 0 17.5751 0 11.5C0 5.42487 4.92487 0.5 11 0.5C17.0751 0.5 22 5.42487 22 11.5Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4941 13.5459C9.27201 13.5459 9.02327 13.5413 8.74788 13.532C8.48138 13.5134 8.18378 13.4902 7.85509 13.4623V12.1233C8.03276 12.1326 8.23264 12.1465 8.45473 12.1651C8.6857 12.1837 8.90334 12.193 9.10766 12.193C9.64067 12.193 10.0937 12.1326 10.4668 12.0117C10.8399 11.8815 11.1242 11.6816 11.3197 11.412C11.5151 11.133 11.6128 10.7704 11.6128 10.3241C11.6128 9.69176 11.4129 9.25009 11.0132 8.99903C10.6223 8.73868 10.0493 8.6085 9.29422 8.6085C9.12543 8.6085 8.91667 8.6178 8.66793 8.63639C8.41919 8.64569 8.14824 8.66429 7.85509 8.69219V7.32532C8.09494 7.30673 8.32147 7.29278 8.53468 7.28348C8.75676 7.27418 8.94776 7.26953 9.10766 7.26953C9.68509 7.26953 10.227 7.32067 10.7333 7.42296C11.2486 7.51594 11.6972 7.67866 12.0792 7.91112C12.4701 8.14358 12.7766 8.45973 12.9986 8.85956C13.2207 9.25009 13.3318 9.7429 13.3318 10.338C13.3318 11.0075 13.1763 11.584 12.8654 12.0675C12.5545 12.551 12.1147 12.9183 11.5462 13.1694C10.9776 13.4204 10.2936 13.5459 9.4941 13.5459ZM11.293 17.4234L7.85509 13.4623L9.72062 13.002L13.5849 17.4234H11.293ZM9.02771 8.35744L9.10766 7.26953H14.3845L14.3045 8.35744H9.02771ZM7.61523 10.9656L7.70851 9.87773H14.3845L14.3045 10.9656H7.61523Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashInactive);
export default __webpack_public_path__ + "static/media/cash_inactive.efdf6133aa505e220fab35bc59571534.svg";
export { ForwardRef as ReactComponent };